import * as React from 'react';
import {Link, useParams} from 'react-router-dom';
import {useCallback, useEffect, useState} from "react";
import {addPayment, getClient} from "../../../api";
import {useHistory} from "react-router";
import {Client, CreditCard} from "../../../types";


const AddPayment: React.FunctionComponent = () => {
    const {clientId} = useParams();
    const [amount, setAmount] = useState("");
    const [createdAt, setCreatedAt] = useState("");
    const [method, setMethod] = useState("");

    const [cardNumber, setCardNumber] = useState("");
    const [cvv, setCvv] = useState("");
    const [zip, setZip] = useState("");
    const [expireMonth, setExpireMonth] = useState("");
    const [expireYear, setExpireYear] = useState("");
    const [doSearchRedirect, setDoSearchRedirect] = useState(false);
    const [creditCards, setCreditCards] = useState<CreditCard[]>([]);
    const [client, setClient] = useState<Client>();
    const [creditCard, setCreditCard] = useState("");

    const history = useHistory();

    useEffect(() => {
        getClient(clientId)
            .then((c) => {
                let cc: CreditCard[] = [];
                c.payments.forEach((p) => {
                    if (p.creditCard !== undefined) {
                        if(cc.filter((s) => s.uuid === p.creditCard?.uuid).length === 0) {
                            cc.push(p.creditCard);
                        }
                    }
                })
                setCreditCards(cc);
                setClient(c);
            })
            .catch((e) => {
                console.log(e);
            })
    }, []);

    useEffect(() => {
        let match = creditCards.filter((c) => c.uuid == creditCard);
        if(match !== undefined && match.length > 0) {
            const cc = match[0];
            setZip(cc.zipCode);
            setCvv(cc.cvv);
            setExpireYear(cc.expirationYear);
            setExpireMonth(cc.expirationMonth);
            setCardNumber(cc.creditCardNumber);
        } else {
            setZip("");
            setCvv("");
            setExpireYear("");
            setExpireMonth("");
            setCardNumber("");
        }
    }, [creditCard])

    useEffect(() => {
        if (doSearchRedirect) {
            history.push({
                pathname: "/m/clients/view/" + clientId
            });
        }
    }, [doSearchRedirect, history, clientId]);

    const getMethodDescription = (method: string) => {
        switch (method) {
            case "CREDIT_CARD":
                return "Credit card";
            case "CASH":
                return "Cash";
            case "CHECK":
                return "Check"
            default:
                return ""
        }
    }

    const doAdd = () => {
        if (method === "CREDIT_CARD" && creditCard !== "") {
            addPayment(clientId, {
                amount: getTotal().toString(),
                paymentDate: createdAt,
                description: getMethodDescription(method) + " payment",
                status: "PROCESSED",
                method: method,
                creditCard: {
                    uuid: creditCard
                }
            }).then((p) => {
                setDoSearchRedirect(true);
            }).catch((e) => console.log(e));
        } else if(method === "CREDIT_CARD" && creditCard === "") {
            addPayment(clientId, {
                amount: getTotal().toString(),
                paymentDate: createdAt,
                description: getMethodDescription(method) + " payment",
                status: "PROCESSED",
                method: method,
                creditCard: {
                    creditCardNumber: cardNumber,
                    cvv: cvv,
                    expirationMonth: expireMonth,
                    expirationYear: expireYear,
                    zipCode: zip
                }
            }).then((p) => {
                setDoSearchRedirect(true);
            }).catch((e) => console.log(e));
        } else {
            addPayment(clientId, {
                amount: getTotal().toString(),
                paymentDate: createdAt,
                description: getMethodDescription(method) + " payment",
                status: "PROCESSED",
                method: method
            }).then((p) => {
                setDoSearchRedirect(true);
            }).catch((e) => console.log(e));
        }
    }

    function getTotal() {
        if(amount) {
            if(method === "CREDIT_CARD" || method === "CASHAPP") {
                return Math.round((parseFloat(amount) * 1.03) * 100) / 100;
            } else {
                return amount;
            }
        }
        return "0";
    }

    return ((client === undefined) ? <>...Loading...</> : <>
        <form>
            <div className={"row"}>
                <div className={"col-lg-12 mb-3 "}>
                    <h2>Add Payment</h2>
                </div>

                <div className={"col-lg-12 mb-3 "}>
                    <h6>Item Details</h6>
                </div>
                <div className={"col-lg-12 mb-3 "}>

                    <div className="form-row align-items-center">

                        <div className="col-sm-2 my-1">
                            <label htmlFor="inputEmail4">Amount</label>
                            <input type="text" className="form-control" id="inlineFormInputName"
                                   value={amount} onChange={(e) => setAmount(e.target.value)}/>
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Transaction Date</label>
                            <input type="date" className="form-control" id="inlineFormInputName"
                                   value={createdAt} onChange={(e) => setCreatedAt(e.target.value)}/>
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Method</label>
                            <select id="inputState" className="form-control"
                                    value={method} onChange={(e) => setMethod(e.target.value)}>
                                <option value={""} disabled={true}>Choose...</option>
                                <option value={"CREDIT_CARD"}>Credit Card</option>
                                <option value={"CASH"}>Cash</option>
                                <option value={"CHECK"}>Check</option>
                                <option value={"CASHAPP"}>Cash App</option>
                            </select>
                        </div>
                        <div className="col-sm-2 my-1">
                            <label htmlFor="inputEmail4">Total</label>
                            <input type="text" className="form-control" id="inlineFormInputName"
                                   disabled={true}
                                   onChange={(e) => {}}
                                   value={getTotal()} />
                        </div>
                    </div>
                </div>
                <div className={"col-lg-12 mb-3"} hidden={method !== "CREDIT_CARD"}>
                    <div className={"row"}>
                        <div className="col-md-3">
                            <label htmlFor="inputEmail4">Saved Cards</label>
                            <select id="inputState" className="form-control"
                                    value={creditCard} onChange={(e) => setCreditCard(e.target.value)}>
                                <option value={""} disabled={false}>New Credit Card</option>
                                {
                                    creditCards.map((cc) => (
                                        <option value={cc.uuid} key={cc.uuid}>{cc.creditCardNumber}</option>
                                    ))
                                }
                            </select>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-lg-12 mb-3 mt-3"}>
                            <h6>Card Information</h6>
                        </div>
                        <div className={"col-lg-12 mb-3 "}>
                            <div className="form-row align-items-center">

                                <div className="col-sm-5 my-1">
                                    <label htmlFor="inputEmail4">Card Number</label>
                                    <input type="text" className="form-control" id="inlineFormInputName"
                                           value={cardNumber} onChange={(e) => setCardNumber(e.target.value)}/>
                                </div>
                                <div className="col-sm-3 my-1">
                                    <label htmlFor="inputEmail4">CVV</label>
                                    <input type="number" className="form-control" id="inlineFormInputName"
                                           value={cvv} onChange={(e) => setCvv(e.target.value)}/>
                                </div>
                                <div className="col-sm-3 my-1">
                                    <label htmlFor="inputEmail4">Zip</label>
                                    <input type="number" className="form-control" id="inlineFormInputName"
                                           value={zip} onChange={(e) => setZip(e.target.value)}/>
                                </div>
                            </div>
                            <div className="form-row align-items-center">

                                <div className="col-sm-2 my-1">
                                    <label htmlFor="inputEmail4">Expire Month</label>
                                    <input type="number" className="form-control" id="inlineFormInputName"
                                           value={expireMonth} onChange={(e) => setExpireMonth(e.target.value)}
                                    />
                                </div>
                                <div className="col-sm-2 my-1">
                                    <label htmlFor="inputEmail4">Expire Year</label>
                                    <input type="number" className="form-control" id="inlineFormInputName"
                                           value={expireYear} onChange={(e) => setExpireYear(e.target.value)}/>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className={"col-lg-12 mb-3 "}>
                    <Link to={"/m/clients/view/" + clientId}>
                        <button type={"submit"} className={"btn btn-danger mr-3"}>Cancel</button>
                    </Link>
                    <button type={"submit"} className={"btn btn-primary"}
                            onClick={(e) => {
                                e.preventDefault();
                                doAdd();
                            }}>Save
                    </button>
                </div>

            </div>
        </form>
    </>);
};

export default AddPayment;